import React, { useEffect, useRef, useState } from 'react';
import { Modal, ModalCloseButton, ModalContent, ModalOverlay } from '@chakra-ui/react';

import { RelevoInterface } from '../../../api/types';
import { DuplicateState } from './states/DuplicateState';
import { ErrorState } from './states/ErrorState';
import { SuccessState } from './states/SuccessState';

type ScanModalProps = {
  status: 'success' | 'duplicate' | 'error';
  isOpen: boolean;
  onClose: () => void;
  item?: RelevoInterface;
};

export const ScanModal = (props: ScanModalProps) => {
  const { isOpen, onClose } = props;

  // Generate a reset token that changes every time the modal opens.
  const [openCounter, setOpenCounter] = useState(0);
  const lastIsOpenRef = useRef<boolean>(false);
  useEffect(() => {
    if (isOpen && !lastIsOpenRef.current) {
      setOpenCounter((v) => v + 1);
    }
    lastIsOpenRef.current = isOpen;
  }, [isOpen]);

  const renderContent = () => {
    switch (props.status) {
      case 'success':
        return <SuccessState item={props.item} onAnimationComplete={onClose} progressResetKey={openCounter} />;
      case 'duplicate':
        return <DuplicateState item={props.item} onAnimationComplete={onClose} progressResetKey={openCounter} />;
      case 'error':
        return <ErrorState onAnimationComplete={onClose} progressResetKey={openCounter} />;
      default: {
        const exhaustiveCheck: never = props.status;
        throw new Error(exhaustiveCheck);
      }
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent p={6} borderRadius="2xl" textAlign="center">
        <ModalCloseButton />
        {renderContent()}
      </ModalContent>
    </Modal>
  );
};
